export const ALLOCATION_GROUPS = {
    NOT_ALLOCATED: 0,
    CONTROL: 1,
    A: 1,
    B: 2,
    C: 3,
    D: 4,
};
